module.exports = __webpack_public_path__ + "img/wechat.d1d1119c.png";